import { toast } from "react-toastify";

export function requestTaskNotificationPermission() {
    if (typeof Notification === "undefined") return Promise.resolve("unsupported");
    if (Notification.permission === "granted") return Promise.resolve("granted");
    if (Notification.permission === "denied") return Promise.resolve("denied");
    return Notification.requestPermission();
}

export function notifyNewTask(task, { role } = {}) {
    const title =
        role === "staff" && task.assigned_by === "Admin"
            ? "New task from admin"
            : "New task";
    const body = task.title || "You have a new task";

    toast.info(`${title}: ${body}`, { autoClose: 6000 });

    if (typeof Notification !== "undefined" && Notification.permission === "granted") {
        try {
            const n = new Notification(title, {
                body,
                tag: `task-${task.id}`,
                renotify: true,
            });
            n.onclick = () => {
                window.focus();
                n.close();
            };
        } catch {
            /* ignore */
        }
    }
}

export function detectNewTasks(prevTasks, nextTasks) {
    if (!prevTasks?.length) return [];
    const prevIds = new Set(prevTasks.map((t) => t.id));
    return nextTasks.filter((t) => !prevIds.has(t.id));
}
